import { render, staticRenderFns } from "./edit-goods-charge.vue?vue&type=template&id=5f569a40&"
import script from "./edit-goods-charge.vue?vue&type=script&lang=js&"
export * from "./edit-goods-charge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports